import { Snackbar} from '@material-ui/core';
import { CircularProgress, Dialog, FlatButton, IconButton } from 'material-ui';
import CloseIcon from 'material-ui/svg-icons/navigation/close';
import * as React from 'react';

class View<P, S> extends React.Component<P & Interfaces.IViewProps, S & Interfaces.IViewState> {

    public static defaultProps: Partial<Interfaces.IViewProps> = {
        loading: false
    }

    constructor(props: any) {
        super(props)
        this.state = {
            isDeleteConfirmationDialogOpened: false,
            snackbarText:''
        } as any
    }

    public onTextChange(e: any) {
        try {
            this.state.model[e.target['name']] = e.target['value'];
            this.clearErrorLabel();
        } catch (e) {
            console.log(e)
        }
    }

    public clearErrorLabel() {
        this.setState({ error: '' })
    }

    public loadingView() {
        const { loading } = this.props
        if (loading) {
            return (
                <div className="loading-view">
                    <CircularProgress size={40} color="black" thickness={2} />
                </div>
            )
        }
        return null
    }

    public errorLabel() {
        const { error } = this.state;
        const { logicError } = this.props;
        if (error || logicError) {
            return <label className="error">{error || logicError}</label>
        }
        return null
    }

    public objectsForDelete():any[]{
        return [];
    }

    public onConfirmDelete() {
        const { onConfirmDelete } = this.props;
        this.setState({isDeleteConfirmationDialogOpened:false});
        if (onConfirmDelete) { onConfirmDelete(this.objectsForDelete()); }
    }

    public closeDeleteConfirmationModal() {
        this.setState({ isDeleteConfirmationDialogOpened: false })
    }

    public deleteConfirmationDialog() {
        const { isDeleteConfirmationDialogOpened } = this.state;
        return (
            <Dialog
                open={isDeleteConfirmationDialogOpened as boolean}
                title="Подтвердите удаление"
                actions={[
                    <FlatButton onClick={() => this.onConfirmDelete()} key="1" label="Удалить" />,
                    <FlatButton onClick={() => this.closeDeleteConfirmationModal()} key="2" label="Отмена" />
                ]}
            >
                Операцию нельзя отменить
            </Dialog>
        )
    }

    public snackbar() {
        const { snackbarText } = this.state;
        return (
            <Snackbar
                message={<span>{snackbarText}</span>}
                open={snackbarText?true:false}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                action={[
                    <IconButton
                    key="close"
                    aria-label="Close"
                    color="inherit"
                    onClick={()=>this.setState({snackbarText:''})}
                    >
                        <CloseIcon color="white" />
                    </IconButton>
                ]}
            />
        )
    }
}

export default View;



// WEBPACK FOOTER //
// ./src/app/abstract/Views/View.tsx